export const EXEMPT_REASONS = [
    { value: 'addy_account', label: 'Addy account' },
    { value: 'pilot', label: 'Pilot' },
    { value: 'partner', label: 'Partner' },
    { value: 'other', label: 'Other' },
];

export const getExemptReasonLabel = (billing = {}) => {
    const reason = EXEMPT_REASONS.find((r) => r.value === billing.billingExemptReason);
    if (!reason) return null;
    if (reason.value === 'other' && billing.billingExemptNote) return `Other: ${billing.billingExemptNote}`;

    return reason.label;
};

export const isGrowthSubscription = (subscription) => {
    if (!subscription || subscription.provider !== 'stripe') return false;
    if (!['active', 'trialing'].includes(subscription.status)) return false;
    const priceId = subscription.priceId || '';
    if (priceId.includes('essentials') || priceId.includes('enterprise')) return false;

    return priceId.includes('growth') || priceId.startsWith('price_');
};

// Enterprise Growth reuses per_user billing: the org keeps its Growth Stripe
// subscription, which the backend and client already read as Enterprise.
export const isEnterpriseGrowthOrg = (organizationData) =>
    organizationData?.billing?.enterpriseGrowth === true &&
    organizationData?.billing?.billingType === 'per_user';
